import { createStyles, makeStyles } from '@material-ui/styles';

export const useTextFieldClasses = makeStyles(() => createStyles({
  input: {
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem'
  }
}));
